import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

// DESIGN.md §3 nomme les CHIPS parmi les surfaces à 5px. Un badge est une
// gélule, pas un cercle : `rounded-full` y était un rayon déguisé en forme, et
// les dix sites d'appel (settings, billing, dashboard) rendent tous sous
// DashboardLayout, donc sur le système de marque.
const badgeVariants = cva(
  'inline-flex items-center rounded-control border px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        outline: 'text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
